// extracted by mini-css-extract-plugin
module.exports = {"container":"logo_container__2-nPu","separator":"logo_separator__2KWqx","coursera":"logo_coursera__2tOcb","google":"logo_google__2VnBb"};